import { TermsConsent } from "@/data/payload/app-account-setting/add-app-account-request-payload";
import { AppAccountSettingRepository } from "@/domain/repository/app-account-setting-repository";
import { SATError, SATResult } from "@sadtx/sat-error";

export class SaveTermsConsentUsecase {
  constructor(private readonly appAccountSettingRepo: AppAccountSettingRepository) {}

  async execute(termsConsent: TermsConsent[]): Promise<SATResult<void, SATError>> {
    return this.appAccountSettingRepo.saveTermsConsent(termsConsent);
  }
}
